var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"huoitem-title"},[(_vm.numPic)?_c('img',{staticClass:"numsrc",attrs:{"src":_vm.numPic}}):_vm._e(),(_vm.contSrc)?_c('img',{staticClass:"contsrc",attrs:{"src":_vm.contSrc}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }